<template>
<div>

  <div :class="[`${classId}`, { 's_active' : hasResults&&!isLoading }]">
    <h6 :class="`${classId}-title`">Suggested clinics</h6>
    <template v-if="localClinics.length">
      <ul :class="`${classId}-list`">
        <li v-for="clinic in localClinics.slice(0, 4)" v-bind:key="clinic.id">
          <a :href=clinic.url @click="selectClinic(clinic, $event)" @mouseover="highlightClinic(clinic, $event)" @mouseleave="unhighlightClinic(clinic, $event)" :class="{ 's_highlighted' : clinic.id == highlightedClinicId, 's_local' : clinic.id == localClinic.id }">{{ clinic.title }}<span v-if="clinic.distance"> &nbsp;&nbsp;{{ clinic.distance }}km</span></a>
          <div :class="`${classId}-popup`" v-if="selectedClinicId == clinic.id">
            <button class="btn l_mini l_stretch l_alt" @click="displayClinic(clinic, $event)">Save as local</button>
            <a :href=clinic.url class="btn l_mini l_stretch l_alt" style="margin-bottom: 0;">View clinic info</a>
            <button @click="deselectClinic" class="btn close-popup">Close</button>
          </div>
        </li>
      </ul>
    </template>
    <template v-else>
      <p>No clinics found within 50km.</p>
      <p>Please try another search or</p>
      <a href="/clinics/directory/" class="btn l_white l_min">View all our clinics</a>
    </template>
  </div>

  <div :class="[`${classId}`, { 's_active' : isEmpty&&!isLoading }]">
    <h6 :class="`${classId}-title`">No clinics found</h6>
    <p>There are currently no clinics available in this region providing the service you're looking for.</p>
  </div>

</div>
</template>

<script>
import EventBus from '../utils/event-bus';

export default {
  name: "SuggestedClinics",
  data() {
    return {

      hasResults: false,

      isEmpty: false,

      isLoading: false,

      localClinics: [],

      highlightedClinicId: false,

      selectedClinicId: false,

      localClinic: false

    };
  },
  props: {
    searchId: String,
    classId: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  computed: {
  },
  methods: {

    deselectClinic(event) {

      // console.log('test');

      this.selectedClinicId = false;
      event.preventDefault();
      return false;

    },

    selectClinic(clinic, event) {

      // console.log(this.searchId);
      if (this.searchId == 'main') {
        this.displayClinic(clinic, event);
      } else {
        if (this.selectedClinicId == clinic.id) {
          this.selectedClinicId = false;
        } else {
          this.selectedClinicId = clinic.id;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      return false;

    },

    displayClinic(clinic, event) {

      this.deselectClinic(event);

      if (this.classId == 'recclinics') {
        EventBus.$emit('CLINIC_DISPLAY', this.searchId, clinic);
        event.preventDefault();
      } else if (this.searchId == 'sidebar') {
        EventBus.$emit('LOCALCLINIC_SET', clinic);
        event.preventDefault();
      } else {
        return;
      }

    },

    highlightClinic(clinic, event) {

      EventBus.$emit('CLINIC_HIGHLIGHT', this.searchId, clinic);

    },

    unhighlightClinic(clinic, event) {

      EventBus.$emit('CLINIC_UNHIGHLIGHT', this.searchId, clinic);

    },

  },
  mounted() {

    EventBus.$on('MAP_POPULATE', (searchId, locations) => {
      if (searchId == this.searchId) {
        this.localClinics = locations;
        this.isLoading = false;
        this.hasResults = true;
      }
    });

    EventBus.$on('MAP_LOADING', (searchId) => {
      if (searchId == this.searchId) {
        this.isLoading = true;
        this.hasResults = false;
      }
    });

    EventBus.$on('CLINIC_HIGHLIGHT', (searchId, clinic) => {
      if (searchId == this.searchId) {
        this.highlightedClinicId = clinic.id;
      }
    });

    EventBus.$on('CLINIC_UNHIGHLIGHT', (searchId, clinic) => {
      if (searchId == this.searchId) {
        this.highlightedClinicId = false;
      }
    });

    EventBus.$on('LOCALCLINIC_EMIT', (clinic) => {
      this.localClinic = clinic;
    });

  },
};
</script>

<style scoped>
</style>